<template>
  <div>
    <div class="head-worktable">
      {{ constLabels[nowLang].header }}
    </div>

    <div class="body-worktable clearfix">
      <div class="txt-typwork clearfix">
        <div class="detail-txt-typwork clearfix" v-for="(typeWork, index) in typeWorks[nowLang]">
            <div class="detail-color">
                <div :class="'color-'+index"></div>
            </div>
            <div class="detail-day">
                <div class=""> {{ typeWork }}</div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hrms-calendar-detail',
  props: [ 'nowLang' ],
  data () {
    return {
      constLabels: {
        en: {
          header: 'Type of Day'
        },
        th: {
          header: 'ประเภทของวันทำงาน'
        }
      },
      typeWorks: {
        en: {
          w: 'Working Day',
          h: 'Holiday',
          t: 'Traditional Day',
          l: 'Leave',
          s: 'Shut down'
        },
        th: {
          w: 'เวลาทำงานปกติ',
          h: 'วันหยุด',
          t: 'วันหยุดประเพณี',
          l: 'การลา',
          s: 'Shut down'
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// hrmsCalendarDetail.vue?fb0f6964